import clsx from 'clsx';
import { RefObject, Dispatch, SetStateAction } from 'react';
import DateInput from '@amplify/date-input';

import { dateService } from 'shared/lib/date';

import { DEFAULT_TIMES, CalendarWidgetPositions } from '../../constants';
import { getTimeFromDate } from '../../lib/utils';

import styles from './styles.module.scss';

type DueDateInputProps = {
  dueDateInputRef: RefObject<HTMLDivElement>;
  dueDate: Date | null;
  onDueDateOptionChangeHandler: () => void;
  onDueDateChangeHandler: (date: Date | null) => void;
  setIsDueDateValid: Dispatch<SetStateAction<boolean>>;
  minDueDate: Date | null;
  maxDate: Date | null;
  isDueDatePopoverOpen: boolean;
  showDueDateValidation: boolean;
  calendarPosition?: CalendarWidgetPositions;
};

export const DueDateInput = ({
  dueDateInputRef,
  dueDate,
  onDueDateOptionChangeHandler,
  onDueDateChangeHandler,
  setIsDueDateValid,
  minDueDate,
  maxDate,
  isDueDatePopoverOpen,
  showDueDateValidation,
  calendarPosition = CalendarWidgetPositions.LEFT,
}: DueDateInputProps) => {
  const defaultDate =
    dueDate && !dateService.dateIsEndOfDay(dueDate) ? dueDate : null;

  const defaultTime = defaultDate
    ? getTimeFromDate(defaultDate.valueOf())
    : DEFAULT_TIMES.dueDateTime;

  return (
    <div
      ref={dueDateInputRef}
      className={clsx(styles.dueDateInputWrapper, 'due-date-input-wrapper')}
      aria-label="Choose a due date"
      onClick={() => onDueDateOptionChangeHandler()}
      onKeyDown={() => onDueDateOptionChangeHandler()}
      role="textbox"
      tabIndex={0}
      data-testid="due-date-input-wrapper"
    >
      <DateInput
        defaultDate={defaultDate}
        defaultTime={defaultTime ?? DEFAULT_TIMES.dueDateTime}
        onDateChange={onDueDateChangeHandler}
        onValidation={setIsDueDateValid}
        minDate={minDueDate}
        maxDate={maxDate}
        showCalendar={isDueDatePopoverOpen}
        showValidation={showDueDateValidation}
        calendarPosition={calendarPosition}
      />
    </div>
  );
};
